import Vue from 'vue';

// 获取时间方法
// Date.prototype.Format = function (str) {
//   let time = this.toLocaleString('chinese', { hour12: false }).toString()
//   let s = str
//   // console.log(time)
//   s = s.replace(/YYYY|yyyy/, time.substr(0, 4))
//   s = s.replace(/MM/, +time.substr(5, 1) < 10 ? "0" + time.substr(5, 1) : time.substr(5, 1))
//   s = s.replace(/DD|dd/, +time.substr(7, 1) < 10 ? "0" + time.substr(7, 1) : time.substr(7, 1))
//   s = s.replace(/HH|hh/, time.substr(10, 2))
//   s = s.replace(/mm/, time.substr(13, 2))
//   s = s.replace(/SS|ss/, time.substr(16, 2))
//   // console.log(s)
//   return s
// }
Date.prototype.Format = function (format) {
  var date = this;
  var map = {
    "M": date.getMonth() + 1,
    "d": date.getDate(),
    "D": date.getDate(),
    "h": date.getHours(),
    "H": date.getHours(),
    "m": date.getMinutes(),
    "s": date.getSeconds(),
    "q": Math.floor((date.getMonth() + 3) / 3),
    "S": date.getMilliseconds()
  };
  format = format.replace(/([yMdDhHmsqS])+/g, function(all, t){
    var v = map[t];
    if(v !== undefined){
      if(all.length > 1){
        v = '0' + v;
        v = v.substr(v.length-2);
      }
      return v;
    }
    else if(t === 'y'){
      return (date.getFullYear() + '').substr(4 - all.length);
    }
    return all;
  });
  return format;
};

// 二进制流下载 res 流 name 文件名
Vue.prototype.$exportExcelData = (res, name) => {
  // 拿到流 设置格式
  var blob = new Blob([res], { type: "application/msword,charset=utf-8" });
  // 兼容ie
  if (window.navigator.msSaveOrOpenBlob) {
    // IE 下载文件
    navigator.msSaveBlob(blob, name);
  } else {
    // 创建a标签
    let ele = document.createElement("a");
    // 通过URL.createObjectURL(blob)可以获取当前文件的一个内存URL 设置下载文件的url地址
    ele.setAttribute("href", URL.createObjectURL(blob));
    // 给a标签设置下载按钮
    ele.setAttribute("download", name);
    // 点击下载开始
    ele.click();
    // 收尾
    ele = null;
  }
}

// 文件下载封装
/**
 * 
 * @param {要下载的数据} data 
 * @param {文件名} name 
 * @param {数据的类型 可以是链接和blob和file对象} type 
 */
Vue.prototype.$fileDownload = (data, name, type = 'string') => {
  if (type === 'string') {
    Vue.prototype.$ComHttp.download({ path: data, name: name }).then(v => {
      Vue.prototype.$exportExcelData(v, name)
    })
  }
  if (type === 'file') {
    Vue.prototype.$exportExcelData(data, name)
  }
}

// 删除上个标签页
Vue.prototype.$deleteBeforeRouter = (thizz) => {
  let str = thizz.$route.path
  let visitedViews = thizz.$store.state.tagsView.visitedViews;
  thizz.$store.state.tagsView.visitedViews = visitedViews.filter(v => v.path !== str);

}
Vue.prototype.$clearSelectDropdownItem = function () {
  // 用于修复滚动条滑动 选择框下拉不收回
  this.$nextTick(function () {
    let el = document.getElementsByClassName('scrollBars')[0]
    el.onscroll = () => {
      if (this.stop) return
      this.stop = true
      try {
        let els = document.getElementsByClassName('el-select')
        for (let i = 0; i < els.length; i++) {
          els[i].__vue__.blur()
        }
      } catch (error) { 
        console.log(error)
      }
      setTimeout(() => {
        this.stop = false
      }, 1000)
    }
  })
}

// 金额显示.00格式
Vue.prototype.$numberAddzero = (value) => {
  if (!value) return '0.00'
  value = value.toFixed(2)
  var intPart = Math.trunc(value) // 获取整数部分
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  var floatPart = '.00' // 预定义小数部分
  var value2Array = value.split('.')
  // =2表示数据有小数位
  if (value2Array.length === 2) {
    floatPart = value2Array[1].toString() // 拿到小数部分
    if (floatPart.length === 1) {
      return intPartFormat + '.' + floatPart + '0'
    } else {
      return intPartFormat + '.' + floatPart
    }
  } else {
    return intPartFormat + floatPart
  }
}